// Supported locales configuration
export const SUPPORTED_LOCALES = [
  { code: "en", label: "English", nativeName: "English", rtl: false },
  { code: "es", label: "Spanish", nativeName: "Español", rtl: false },
  { code: "fr", label: "French", nativeName: "Français", rtl: false },
  { code: "pt", label: "Portuguese", nativeName: "Português", rtl: false },
  { code: "ar", label: "Arabic", nativeName: "العربية", rtl: true },
  { code: "ur", label: "Urdu", nativeName: "اردو", rtl: true },
  { code: "fa", label: "Persian", nativeName: "فارسی", rtl: true },
  { code: "hi", label: "Hindi", nativeName: "हिन्दी", rtl: false },
  { code: "zh", label: "Chinese", nativeName: "中文", rtl: false },
] as const;

export type LocaleCode = (typeof SUPPORTED_LOCALES)[number]["code"];

export const DEFAULT_LOCALE: LocaleCode = "en";

export const RTL_LOCALES: LocaleCode[] = ["ar", "ur", "fa"];

export function isRTL(locale: string): boolean {
  return RTL_LOCALES.includes(locale as LocaleCode);
}

export function getLocaleConfig(code: string) {
  return SUPPORTED_LOCALES.find((l) => l.code === code) || SUPPORTED_LOCALES[0];
}

// Cookie and storage keys
export const LOCALE_COOKIE_NAME = "adigo_locale";
export const LOCALE_STORAGE_KEY = "adigo_locale";
export const LOCALE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year
